// EntityType-specific validation - Uses generic validation utility
import { createValidation } from '../../utils/validation';

/**
 * EntityType-specific validation factory
 * This is a thin wrapper around the generic validation utility
 * for backwards compatibility with existing entityType module code
 */
export const createEntityTypeValidation = (fields) => {
  const validation = createValidation(fields);
  
  // Return both generic and specific method names for flexibility
  return {
    schema: validation.schema,
    validateData: validation.validateData, // Generic name for configInit
    validateEntityTypeData: validation.validateData, // Specific name for backwards compatibility
    validateField: validation.validateField
  };
};

// Default export for backwards compatibility
export default createEntityTypeValidation;
